import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import NavigationLinks from './navigation-links'
import * as styles from '../footer/footer.module.scss'

const MenuFooter = () => {
  const data = useStaticQuery(graphql`
    {
      footer: allDatoCmsPctNavigation(
        filter: { codeId: { eq: "navigation-footer-navigation" } }
      ) {
        nodes {
          navigationItems {
            ...PctNavigationItems
          }
        }
      }
    }
  `)
  const footerNavigationItems = data?.footer?.nodes[0].navigationItems
  return footerNavigationItems?.map((el) => (
    <div className={`col-lg-3 col-md-6 col-12 ${styles.colMenu}`} key={el.id}>
      <h3 className="pb-2">{el.externalName}</h3>
      <NavigationLinks
        className={styles.listNavFooter}
        items={el.navigationLinks}
        showDescription={false}
      />
    </div>
  ))
}

export default MenuFooter
